<template>
  <div>
    <Title v-if="!isAdmin" :showMinister="true" :showService="true" />

    <Breadcrumb :links="breadCrumbData" />

    <Carrusel />

    <div class="container">
      <Buttons />
    </div>

    <h3 class="h3">Evaluaciones - Informe Preliminar</h3>

    <div v-if="permission">
      <AlertError />
    </div>

    <div class="container" v-else>
      <div v-for="(item, items) in items" :key="items">
        <h5>
          Programa / Institución:
          <span>{{ item.programa }}</span>
        </h5>

        <h5>
          Año Evaluación:
          <span>{{ item.anio }}</span>
        </h5>

        <h5>
          Fecha del Informe:
          <span>{{ item.vencimiento }}</span>
        </h5>

        <div class="div-table"></div>
        <div class="div-table">
          <h6>
            Cumplimiento de Compromisos de Programas / Instituciones Evaluadas
          </h6>
        </div>
        <table>
          <thead>
            <tr>
              <th scope="col">Compromiso</th>
              <th scope="col">Cumplimiento</th>
            </tr>
          </thead>
          <tbody>
            <tr class="tr">
              <td>{{ item.compromiso }}</td>
              <td scope="col" colspan="2">{{ item.cumplimiento }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "../../../../components/private/Title";
import Breadcrumb from "@/components/tools/Breadcrumb.vue";
import Carrusel from "../../../../components/private/Carrusel.vue";
import Buttons from "./Buttons.vue";
import { mapState } from "vuex";
import axiosClient from "@/config/axiosClient";
import AlertError from "../../../../components/error/AlertError.vue";
import { showAlert } from "../../../../components/tools/utils";

export default {
  components: {
    Title,
    Breadcrumb,
    Carrusel,
    Buttons,
    AlertError,
  },
  data() {
    return {
      permission: true,
      breadCrumbData: null,
      items: null,
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
  },
  methods: {
    setBreadcrumbData: function() {
      this.breadCrumbData = [
        {
          name: "Portada BGI",
          routeName: "bgi",
          routeParams: {
            idUsuario: this.usuario.id,
          },
        },
        {
          name: "Escritorio de Gestión Virtual",
          routeName: "buttons",
          routeParams: {
            idUsuario: this.usuario.id,
            idServicio: this.$route.params.idServicio,
          },
        },
        {
          name: "Evaluaciones - Informe Preliminar",
          routeName: "informepreliminar",
          routeParams: {
            idServicio: this.$route.params.idServicio,
          },
        },
      ];
    },

    obtenerContenido: async function() {
      try {
        const res = await axiosClient.get(
          `/anexos/anexo/public_list/?anexo=6&servicio=${this.$route.params.idServicio}`
        );
        if (res.data) {
          this.items = res.data[0].datos.original[`${process.env.VUE_APP_ANIO}`];
          this.permission = false;
        }

        //  this.suma  = parseInt(this.anio) + parseInt(this.sum);
        console.log(this.anio);

        console.log("this items", res.data);
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.setBreadcrumbData();
    this.obtenerContenido();
    showAlert({
      icon: "success",
      text: "Espere un momento mientras carga los datos",
      timerProgressBar: true,
      timer: 5000,
    });
  },
};
</script>

<style scoped>
.h3 {
  text-align: center;
}

.container {
  margin-top: 20px;
}

th {
  text-align: center !important;
  font-size: 14px !important ;
}

td {
  text-align: left;
}

table {
  margin-bottom: 20px;
}

.col-Left {
  color: #052333;
  font-weight: bold;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  width: 20%;
  padding: 5px;
  text-align: left !important;
}

.tr {
  border: 1px solid #000;
}

h6 {
  text-align: center;
  margin: 0;
  color: #052333;
  font-weight: bold;
}

.div-table {
  background: #efefef;
  margin: 0;
}
h5 {
  text-align: left;
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: bold;
  color: #052333;
}

span {
  font-weight: 400;
}
</style>
